import { DocumentRejectionReasonEnum } from 'common/document/enums/document-rejection-reason.enum';
import { DocumentRequestEventNameEnum } from '../enums/document-request-event-name.enum';
import { IDocumentRequestEvent } from '../interfaces/document-request-event';
import { DocumentRequestEventNameLabel } from './document-request-event-name.map';

export function generateDocumentRequestEventName(
  event: IDocumentRequestEvent
): string {
  const eventNameLabell = DocumentRequestEventNameLabel[event.eventName];

  if (
    [
      DocumentRequestEventNameEnum.DOCUMENT_REQUEST_SMS_ERROR,
      DocumentRequestEventNameEnum.DOCUMENT_REQUEST_SMS_DELIVERED,
      DocumentRequestEventNameEnum.DOCUMENT_REQUEST_SMS_STATUS_CHANGED,
      DocumentRequestEventNameEnum.DOCUMENT_APPROVED_SMS_STATUS_DELIVERED,
      DocumentRequestEventNameEnum.DOCUMENT_APPROVED_SMS_STATUS_FAILED,
    ].includes(event.eventName)
  ) {
    return `${eventNameLabell} ${event.detailsMessage}`;
  }

  if (
    event.eventName === DocumentRequestEventNameEnum.DOCUMENT_REJECTED &&
    event.detailsMessage
  ) {
    if (event.detailsMessage.includes(DocumentRejectionReasonEnum.OTHER)) {
      const [, rejectionReasonDetails] =
        event?.detailsMessage?.split('OTHER:') || [];
      if (rejectionReasonDetails) {
        return `${eventNameLabell} for reason: ${rejectionReasonDetails}`;
      }
      return eventNameLabell;
    }
    if (event.documentName) {
      return event.detailsMessage.replace(event.documentName, '');
    }
    return event.detailsMessage;
  }

  return DocumentRequestEventNameLabel[event.eventName];
}
